// import { injectReducer } from 'store/reducers'
import { actions as ptpActions } from 'store/newParticipant'
import { noticeActions } from 'store/notice'

const { LANDING_MESSAGE_ENABLED, HAPPY_HUMI } = process.env
const landingMessage = LANDING_MESSAGE_ENABLED === 'YES'
const isPositiveMessage = HAPPY_HUMI === 'YES'

// Sync route definition
export default store => ({
  path: 'signup',
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const SignUpPage = require('./containers/SignUpContainer').default
        store.dispatch(ptpActions.initializePage())
        if (landingMessage) store.dispatch(noticeActions.openNotice({
          className: 'notice',
          noButtons: true,
          closeOnBackgroundClick: true,
          humi: true,
          happyHumi: isPositiveMessage,
          closeX: true,
        }))
        cb(null, SignUpPage)
      },
      'signup',
    )
  },
})



// WEBPACK FOOTER //
// ./src/routes/SignUp/index.js